import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BrandService } from '../../business-services/brand.service';


@Injectable({ providedIn: 'root' })
export class EditBrandGuard  {

  constructor(
    private brandService: BrandService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.brandService.brandId) {
      return true;
    }
    return this.router.createUrlTree(['/brand']);
  }
}
